$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function baseUrl() {
    pathArray = window.location.href.split( '/' );
    protocol = pathArray[0];
    host = pathArray[2];
    url = protocol + '//' + host;

    return url;
}

var base_url = baseUrl();

function confirmDelete(){
    return confirm("¿Are you sure you want to delete this item?");
}

$('input, textarea').placeholder();

function alignMiddleElements(){

  $('.align-middle').each(function(){

    var height = $(this).closest('.reference').height();
    $(this).css('min-height', height);

    if($(this).find('div.align-middle-wrapper').length < 1){
      $(this).wrapInner('<div class="align-middle-wrapper"></div>');
    }

    $(this).find('div.align-middle-wrapper').css('height', height);
    $(this).find('div.align-middle-wrapper').css('width', $(this).width());
  });

}

function is_encoded(str) {
	return decodeURIComponent(str) !== str;
}

function encode(str) {
	if (this.is_encoded(str)) {
		return str;
	} else {
		return encodeURIComponent(str);
	}
}

function popup(url, params)
{
	var k, popupVars, qs, v;
	if (params == null) {
		params = {};
	}
	popupVars = {
		width: 500,
		height: 350
	};
	popupVars.top = (screen.height / 2) - (popupVars.height / 2);
	popupVars.left = (screen.width / 2) - (popupVars.width / 2);
	qs = ((function() {
		var _results;
		_results = [];
		for (k in params) {
			v = params[k];
			_results.push("" + k + "=" + (this.encode(v)));
		}
		return _results;
	}).call(this)).join('&');
	if (qs) {
		qs = "?" + qs;
	}
	return window.open(url + qs, 'targetWindow', "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,left=" + popupVars.left + ",top=" + popupVars.top + ",width=" + popupVars.width + ",height=" + popupVars.height);
}

$('.share-fb').click(function(){
	if(typeof $(this).attr('data-share-url') !== 'undefined'){
		base_url = $(this).attr('data-share-url');
	}

	popup('http://www.facebook.com/sharer.php', {
      u: base_url
    });

    return false;
});

$('.share-tw').click(function(){
	if(typeof $(this).attr('data-share-url') !== 'undefined'){
		base_url = $(this).attr('data-share-url');
	}

	popup('https://twitter.com/intent/tweet', {
      text: $(this).attr('data-share-title') + ' ',
      url: base_url
    });

    return false;
});

//bootstrapValidator

$(document).ready(function() {
    $('#contactForm').bootstrapValidator({
        message: 'Valor inválido',
        feedbackIcons: {
            valid: 'glyphicon glyphicon-ok',
            invalid: 'glyphicon glyphicon-remove',
            validating: 'glyphicon glyphicon-refresh'
        },
    })
	.on('success.form.bv', function(e) {

        // Prevent form submission
        e.preventDefault();



        // Get the form instance
        var $form = $(e.target);

        // Get the BootstrapValidator instance
        var bv = $form.data('bootstrapValidator');

        $.post($form.attr('action'), $form.serialize(), function(result) {

          var paypal_form_wrapper = $('#paypalForm');
          var form_submit_btn = $('#contactForm input[name="submit"]');

          if (result.status === true || result.status === 'ok') {

            locale = '<input type="hidden" name="lc" value="GB">';
            if(result.applang === 'es') {
              locale = '<input type="hidden" name="lc" value="MX">';
            }

          	paypal_form_wrapper.html('<form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" ><input type="hidden" name="cmd" value="_donations"><input type="hidden" name="business" value="raloni@hadassah.org">'+locale+'<input type="hidden" name="item_name" value="('+result.country+') Hadassah International"><input type="hidden" name="amount" value="'+result.amount+'"><input type="hidden" name="currency_code" value="USD"><input type="hidden" name="item_number" value="'+result.project+'"><input type="hidden" name="no_note" value="1"><input type="hidden" name="no_shipping" value="1"><input type="hidden" name="rm" value="1"><input type="hidden" name="return" value="'+base_url+'/donation/thankyou/'+result.applang+'"><input type="hidden" name="cancel_return" value="'+base_url+'/donation/'+result.applang+'"><input type="hidden" name="bn" value="PP-DonationsBF:btn_donate_LG.gif:NonHosted"><input type="image" src="https://www.paypalobjects.com/es_XC/i/btn/btn_donate_LG.gif" border="0" name="submit" alt="PayPal, la forma más segura y rápida de pagar en línea."><img alt="" border="0" src="https://www.paypalobjects.com/en_GB/i/btn/btn_donate_LG.gif" width="1" height="1"></form>');

            var paypal_form = $('#paypalForm form');

            paypal_form_wrapper.css('opacity', 0);
            form_submit_btn.attr('disabled', 'disabled');
            form_submit_btn.css('opacity', 0.8);
            form_submit_btn.attr('src', base_url + '/dist/img/ajax-loader.gif');

	          paypal_form.submit();
          } else {
            $('#errors').html(result.message).removeClass('hide');
            $('#contactForm').bootstrapValidator('disableSubmitButtons', false);
          }
        }, 'json');
    });
});


// Dependent Dropdown

$('#dependent_dropdown_projects').cascadingDropdown({
    selectBoxes: [
        {
            selector: '.step1'
        },
        {
            selector: '.step2',
            requires: ['.step1'],
            requireAll: true,
            source: function(request, response) {
                $('#description-project').html('<img src="' + base_url + '/dist/img/ajax-loader.gif">');

                $.getJSON(base_url + '/json/busqueda/projects/' + request.lang, request, function(data) {
                    if($('select.step2').hasClass('selectized')){
                        $('select.step2')[0].selectize.destroy();
                        $('select.step2').removeClass('selectized');
                    }
                    var selectOnlyOption = data.length <= 1;
                    response($.map(data, function(item, index) {
                        return {
                            label: item.Label,
                            value: item.Value,
                            selected: selectOnlyOption
                        };
                    }));
                    $('select.step2').selectize();
                    $('#description-project').html('');
                });
            }
        }
    ],
    onChange: function(event, dropdownData) {

        $('#description-project').html('<img src="' + base_url + '/dist/img/ajax-loader.gif">');

        if(dropdownData.project !== ''){
            $('#description-project').html('<img src="' + base_url + '/dist/img/ajax-loader.gif">');
            $.getJSON(base_url + '/json/busqueda/projects/' + dropdownData.project + '/' + dropdownData.lang, dropdownData, function(data) {

                var length = data.length;
                if(length > 0 && data[0].description != null){
                    $('#description-project').html(data[0].description.replace(/\r?\n|\r/g, "<br>"));
                }else{
                    $('#description-project').html('');
                }

                if(length > 0 && data[0].price != null && data[0].price > 0){
                    $('#amount').val(parseInt(data[0].price));
                    $('#amount').prop('readonly', true);
                    $('#contactForm').data('bootstrapValidator').revalidateField('amount');
                }else{
                    $('#amount').prop('readonly', false);
                    $('#contactForm').data('bootstrapValidator').revalidateField('amount');
                }
            });
        }else{
            $('#description-project').html('');
            $('#amount').prop('readonly', false);
            $('#contactForm').data('bootstrapValidator').revalidateField('amount');
        }

    },
    onReady: function(event, dropdownData) {

    }
});

$(document).ready(function() {
    alignMiddleElements();

    $(function() {
        $('select').each(function(){
            $(this).selectize();
        });
    });

    $('.confirm-delete').click(function() {
      return confirmDelete();
    });
});

$(window).load(function() {
    $('.cookie-message').cookieBar({
      // custom close button
      'closeButton': '.cookiebar-close',
    });
    alignMiddleElements();
});

$(window).resize(function() {
    alignMiddleElements();
});
